/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/*jslint white: true */
/*jslint node: true */
/*global $, jQuery, Swiper, ScrollMagic*/

var ms_ie = false;
var ua = window.navigator.userAgent;
var old_ie = ua.indexOf('MSIE ');
var new_ie = ua.indexOf('Trident/');

if ((old_ie > -1) || (new_ie > -1)) {
	ms_ie = true;
}

if ( ms_ie ) {

	//IE specific code goes here
	$.fancybox.open({
		src  : objects.url_theme+'/templates-parts/ie-popup.php?url_theme='+encodeURIComponent(objects.url_theme)+'&site_name='+encodeURIComponent(objects.site_name),
		type : 'ajax',
		opts : {
			afterShow : function() {
				$(".fancybox-container").on('click', '.btnclose', function(btnclose) {
						btnclose.preventDefault();
						btnclose.stopPropagation();
						$(this).parent().hide();
						$.fancybox.close();
				});
			}
		}
	});

	$('body').append('<link rel="stylesheet" type="text/css" href="'+objects.url_home+'/wp-content/themes/zekario/assets/css/popup-ie.min.css">')
}